import React from 'react';
import { Icon } from '@iconify/react';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="p-2 rounded-full text-white bg-gray-700 hover:bg-neutral-500 transition-colors duration-300"
      aria-label="Toggle theme"
    >
      {theme === 'light' ? (
        <Icon icon="mdi:weather-night" className="w-6 h-6" />
      ) : (
        <Icon icon="mdi:weather-sunny" className="w-6 h-6 text-yellow-400" />
      )}
    </button>
  );
};

export default ThemeToggle;